import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Select, Spin } from 'antd';
import Footer from '../../components/footer/footer';
import Banner from '../../components/about/banner'
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux"
import { getStudents } from '../../../../core/actions/allUsers';
import { getPosts } from '../../../../core/actions/postGet';
import { getCourses } from '../../../../core/actions/courseGet';

class About extends Component {
  constructor(props) {
    super(props)
    this.state = {
      students: [],
      blogPost: [],
      courses: []
    }
  }

  componentDidMount() {
    const { courses, students, blogPost } = this.state;
    if (!courses.length) {
      this.props.getCourses();
    }
    if (!students.length) {
      this.props.getStudents();
    }
    if (!blogPost.length) {
      this.props.getPosts()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { blogPost, courses, students } = nextProps;
    if (courses.length > 0) {
      this.setState({ courses });
    }
    if (students.length > 0) {
      this.setState({ students });
    }
    if (blogPost.length > 0) {
      this.setState({ blogPost });
    }
  }

  render() {
    const { courses, students, blogPost } = this.state;
    const { profile } = this.props
    return (
      <div className="aboutus">
        <Helmet>
          <title>Contact Us</title>
          <meta name="description" content=" Have anyting to discuss with us? We are always ready to help!" />
        </Helmet>
        <TopNav />
        <Banner />
        <div class="about-text">
          <div class="container">
            <div class="wrapper">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <img src="/img/1.jpg" alt="" class="space" />
                  <div class="theme-title">
                    {/* <h6>Title here</h6> */}
                    <h2>Our Mission</h2>
                  </div>
                  <p>Lorem ipsum dolor sit amet, ut nec errem offendit omittantur, sed tota erroribus conceptam ei, unum meliore . Dicit discere nostrum ei mea, no qui labore convenire. Vis reque populo ex. Te eam agam reque rationibus, an facete tritani has. Idque dsu postulant ea sea, ei mel elitr ponderum.</p>
                </div>
                <div class="col-sm-6 col-xs-12 m-fix">
                  <div class="theme-title">
                    {/* <h6>About us</h6> */}
                    <h2>Who We Are</h2>
                  </div>
                  <p class="space">Lorem ipsum dolor sit amet, ut nec errem offendit omittantur, sed tota erroribus conceptam ei, unum meliore . Dicit discere nostrum ei mea, no qui labore convenire. Vis reque populo ex. Te eam agam reque rationibus, an facete tritani has. Idque dsu postulant ea sea, ei mel elitr ponderum.</p>
                  <img src="/img/2 (1).jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="theme-counter">
          <div class="count-particles">
            <span class="js-count-particles">--</span>
          </div>
          <div id="particles-js"></div>
          <div class="opacity">
            <div class="container">
              <div class="row">
                <div class="col-sm-4 col-xs-12">
                  <h3><span class="counter">{students.length}</span>+</h3>
                  <p>Students</p>
                </div>
                <div class="col-sm-4 col-xs-12">
                  <h3><span class="counter">{courses.length}</span>+</h3>
                  <p>Courses</p>
                </div>
                <div class="col-sm-4 col-xs-12">
                  <h3><span class="counter">{blogPost.length}</span>+</h3>
                  <p>News</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="amazing-feature" style={{ paddingTop: 0 }}>
          <div className="container">
            <h2>Get Notified <br />About this Amazing Features</h2>
            <div className="row" >
              <div className={`col-xs-6 ${profile.uid ? 'getnotified' : null}`}>
                <div className="single-box float-right tran3s xcursor" onClick={() => this.props.history.push('/contact')}>
                  <i className="flaticon-compose"></i>
                  <h6><a href="#" className="tran3s">Write us</a></h6>
                  <p>Whether you’re looking to start a new career or change your current one, Orsity help you become job ready.</p>
                </div>
              </div>
              {
                !profile.uid ? <div className="col-xs-6">
                  <div className="single-box tran3s xcursor" onClick={() => this.props.history.push('/signup')}>
                    <i className="flaticon-light-bulb"></i>
                    <h6><a href="#" className="tran3s">Sign up Now!!</a></h6>
                    <p>Creating a free account will allow you to view all of the free courses orsity has to offer as well as tracking your progress as you learn.</p>
                  </div>
                </div> : null
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getCourses,
  getStudents,
  getPosts
}, dispatch);

const mapStateToProps = state => ({
  courses: state.getCourses.courses,
  blogPost: state.allPosts.posts,
  students: state.allUsers.students,
  profile: state.firebase.profile,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(About);
